"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const allObservable = (exclude) => {
    return function (BaseClass) {
        return class extends BaseClass {
            constructor(...args) {
                super(...args);
                for (const key of Object.keys(this)) {
                    if (typeof this[key] !== 'function' && shouldAddObservable(key, exclude || [])) {
                        this[key] = mobx_1.observable.box(this[key]);
                    }
                }
            }
        };
    };
};
exports.allObservable = allObservable;
const shouldAddObservable = (key, excludedArray) => excludedArray.length > 0 ? excludedArray.indexOf(key) : true;
//# sourceMappingURL=all-observable.js.map